export default "__VITE_ASSET__Be4J$H_s__"